import {createContext} from 'react'
import { useState } from "react";

export const CartContext = createContext(null)
const ShopingCartContextProvider = ({children}) => {
    const [cart, setCart] = useState([])
    const [enviadoPara, setEnviadoPara] = useState(false);
    const [enviadoAclaracion, setEnviadoAclaracion] = useState(false);  
    const [enviadoDomicilio, setEnviadoDomicilio] = useState(false);
  return (
    <CartContext.Provider  value = {{cart, setCart,enviadoPara, setEnviadoPara,enviadoAclaracion, setEnviadoAclaracion,enviadoDomicilio, setEnviadoDomicilio}}>
        {children}
    </CartContext.Provider>
  )
}

export default ShopingCartContextProvider